'use client';

import React from 'react';
import { Modal, ModalContent, ModalHeader, ModalBody, ModalFooter, Button } from '@heroui/react';
import { CustomHeroButton, ResponsiveModal, Typography } from '../../../../../components';
import { useNavigate } from 'react-router';
import { IcModalSuccess } from '../../../../../components/icons';
import { useTranslations } from '../../../../../contexts/translation.context';

interface SuccessModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const SuccessModal: React.FC<SuccessModalProps> = ({ isOpen, onClose }) => {
  const navigate = useNavigate();
  const { t } = useTranslations();

  const handleGoToOffers = () => {
    onClose();
    navigate('/partner/subscribers/sales');
  };

  return (
    <ResponsiveModal
      isOpen={isOpen}
      onClose={handleGoToOffers}
      placement="center"
      size="md"
      classNames={{
        base: 'bg-white w-[25rem]',
        backdrop: 'bg-black/50',
      }}
    >
      <ModalContent>
        {(onClose) => (
          <>
            <ModalHeader className="flex p-6 pb-4 gap-2 ">
              <IcModalSuccess />
              <Typography variant="h6" className="font-semibold text-auth-ink">
                {t('successModal.offerOnModeration')}
              </Typography>
            </ModalHeader>
            <ModalBody>
              <Typography variant="body2">
                {t('successModal.offerWillBePublished1')}
                <br />
                {t('successModal.offerWillBePublished2')} &nbsp;
                <a
                  style={{ color: '#006FEE', cursor: 'pointer' }}
                  target="_blank"
                  href="https://t.me/onlyu_partners"
                >
                  @onlyu_partners
                </a>
                .
              </Typography>
            </ModalBody>
            <ModalFooter className="flex items-end">
              <CustomHeroButton
                size="sm"
                onPress={handleGoToOffers}
                title={t('successModal.close')}
              />
            </ModalFooter>
          </>
        )}
      </ModalContent>
    </ResponsiveModal>
  );
};

export default SuccessModal;
